// removed by extract-text-webpack-plugin
module.exports = {"links":"_3yT5YC1s","link":"_1Be0ORSj","inner":"_23X5rbct","text":"_3R43mU4o","icon":"_1Z8jjG7d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Menu/Menu.pcss
// module id = 378
// module chunks = 0